import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import MenuItems from './MenuItems';
import MenuItemList from '../../data/reshto.json';
import { Link } from 'react-router-dom';
import SectionTitle from '../ui/SectionTitle';
import { motion } from 'framer-motion';

export default function OurMenu() {
    const [MenuItemListData] = useState(MenuItemList);
    
    return (
        <>
            <motion.section className='section' id='menu' initial={{opacity: 0, y: 50}} viewport={{once: true}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>
                <Container className='position-relative'>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Explore Our Menu"/>
                        </Col>

                        <Col md={12}>
                            <Tab.Container id="pills-tab" defaultActiveKey="breakfast">
                                <Row className="mb-4">
                                    <Col sm={12}>
                                        <Nav variant="pills" className='justify-content-center'>
                                            <Nav.Item>
                                                <Nav.Link eventKey="breakfast">Breakfast</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="lunch">Lunch</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="dinner">Dinner</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="dessert">Dessert</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="drink">Drink</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="breakfast">
                                                <MenuItems menuData={MenuItemListData.BreakfastMenuItemData} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="lunch">
                                                <MenuItems menuData={MenuItemListData.LunchMenuItemData} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="dinner">
                                                <MenuItems menuData={MenuItemListData.DinnerMenuItemData} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="dessert">
                                                <MenuItems menuData={MenuItemListData.DessertMenuItemData} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="drink">
                                                <MenuItems menuData={MenuItemListData.DrinkMenuItemData} />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                    <Col md={12} className='text-center mt-4'>
                                        <Link to="/food_menu" className="btn btn-danger">View All <i className="ri-arrow-right-fill ms-1"></i></Link>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
